/** Prefix a root-relative app path with the deploy base (vite --base), e.g. /loancracker. */
export const appUrl = (path: string): string =>
    path.startsWith('/') && !path.startsWith('//')
        ? `${import.meta.env.BASE_URL.replace(/\/$/, '')}${path}`
        : path;
